import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, Scale, TrendingUp, ShoppingCart } from 'lucide-react';

const benefits = [
  { icon: Shield, title: "Nationwide Legal Authority", text: "Federal registration grants exclusive rights across all 50 states. Stop unauthorized use, pursue infringers in court, and claim statutory damages." },
  { icon: Scale, title: "Credibility & Trust", text: "The registered symbol signals legitimacy to customers, investors, and partners. It elevates your brand from informal to legally recognized." },
  { icon: TrendingUp, title: "Asset That Appreciates", text: "A trademark is intellectual property that grows in value. It strengthens your position in licensing, franchising, and acquisition negotiations." },
  { icon: ShoppingCart, title: "Amazon Seller Advantage", text: "A registered trademark is your ticket to Amazon Brand Registry. Unlock A+ Content, Sponsored Brands, and automated IP protection tools." }
];

const WhyNeedSection = ({ onOpenContactForm }) => {
  return (
    <section data-testid="why-need-section" className="py-24 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">Why Register</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-6">
              Your Brand Deserves Federal Protection
            </h2>
            <p className="text-base text-[#4B5563] leading-relaxed mb-10">
              Without trademark registration, your brand name, logo, and identity are exposed. <strong className="text-[#0A0F1C]">Trademark Logo Design</strong> establishes exclusive ownership through the USPTO and gives you the legal foundation to defend what you've built.
            </p>
            <Button
              data-testid="why-need-cta"
              onClick={onOpenContactForm}
              className="bg-[#002FA7] hover:bg-[#002280] text-white font-medium px-8 py-5 rounded-none transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(0,47,167,0.3)]"
            >
              Protect My Brand <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {benefits.map((b, i) => (
              <div
                key={i}
                data-testid={`benefit-card-${i}`}
                className="group bg-white border border-[#E5E7EB] p-7 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(10,15,28,0.06)] hover:border-[#002FA7]/30"
              >
                <div className="w-11 h-11 border border-[#E5E7EB] flex items-center justify-center mb-5 group-hover:border-[#002FA7]/30 group-hover:bg-[#002FA7]/5 transition-all duration-500">
                  <b.icon className="w-5 h-5 text-[#002FA7]" />
                </div>
                <h4 className="text-lg font-bold text-[#0A0F1C] mb-2">{b.title}</h4>
                <p className="text-sm text-[#4B5563] leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNeedSection;
